import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import useTunnelBookingType from '@/routes/tunnel/context/hooks/useTunnelBookingType';
import useTunnelExperience from '@/routes/tunnel/context/hooks/useTunnelExperience';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import buildTunnelHref from '@/utils/routes/buildTunnelHref';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { useNavigate } from 'react-router-dom';
import useIsBookingStep from '../../../context/hooks/useIsBookingStep';
import useIsValidationStep from '../../../context/hooks/useIsValidationStep';
import ExperienceStep from './ExperienceStep';
import Step from './Step';
const TunnelStepper = () => {
    const $ = _c(21);
    const translate = useTranslate();
    const isBookingStep = useIsBookingStep();
    const isValidationStep = useIsValidationStep();
    const { experienceId } = useTunnelExperience();
    const bookingType = useTunnelBookingType();
    const navigate = useNavigate();
    const t0 = bookingType === FTunnelPageBookingTypeEnum.voucher ? "messages.voucher" : "messages.booking";
    let t1;
    if ($[0] !== t0 || $[1] !== translate) {
        t1 = capitalize(translate(t0));
        $[0] = t0;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const bookingLabel = t1;
    let t2;
    if ($[3] !== bookingType || $[4] !== experienceId || $[5] !== navigate) {
        t2 = () => {
            navigate(buildTunnelHref(bookingType, experienceId), { replace: true });
        };
        $[3] = bookingType;
        $[4] = experienceId;
        $[5] = navigate;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    const handleBookingStepClick = t2;
    let t3;
    if ($[7] !== translate) {
        t3 = capitalize(translate("messages.validation"));
        $[7] = translate;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    const validationLabel = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <ExperienceStep />;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    const t5 = !isBookingStep;
    let t6;
    if ($[10] !== bookingLabel || $[11] !== handleBookingStepClick || $[12] !== isBookingStep || $[13] !== t5) {
        t6 = <Step number={2} onClick={handleBookingStepClick} isActive={isBookingStep} isDone={t5}>

      {bookingLabel}
    </Step>;
        $[10] = bookingLabel;
        $[11] = handleBookingStepClick;
        $[12] = isBookingStep;
        $[13] = t5;
        $[14] = t6;
    }
    else {
        t6 = $[14];
    }
    let t7;
    if ($[15] !== isValidationStep || $[16] !== validationLabel) {
        t7 = <Step number={3} isActive={isValidationStep} isDone={false} noArrow={true}>
      {validationLabel}
    </Step>;
        $[15] = isValidationStep;
        $[16] = validationLabel;
        $[17] = t7;
    }
    else {
        t7 = $[17];
    }
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
        t8 = <div className="tunnel-stepper flex flex-row h-10 overflow-hidden rounded-t -mx-px xs:h-12 sm:h-14 md:h-18">{t4}{t6}{t7}
    </div>;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    }
    else {
        t8 = $[20];
    }
    return t8;
};
export default TunnelStepper;
